import React, { useContext } from 'react';
import { SignUpForm } from '../forms';
import { GlobalSiteDataContext } from '../../context';

export function SignUpModal({ showSignUpModal, setShowSignUpModal }) {
    const siteData = useContext(GlobalSiteDataContext);
    return <SignUpForm {...{ siteData, showSignUpModal, setShowSignUpModal }} />;
}

export default SignUpModal;
